<template>
  <v-card>
    <v-card-title>
      Voting progress
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table"
      />

      <v-data-table
        v-else
        :headers="judgingSummaryHeaders"
        :items="teamResults"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import { mapGetters } from 'vuex';

export default {
  name: 'VotingProgress',
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
    teamResults: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      eventId: this.$store.state.hackathonID,
      missing: [],
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
    judgingSummaryHeaders() {
      return [
        { text: 'Team', value: 'name' },
        { text: 'Voted Received', value: 'votesReceived' },
        { text: 'Votes Received Percentage', value: 'votesReceivedPercentage' },
      ];
    },
  },
  mounted() {
    this.getVotingProgress();
  },
  methods: {
    async getVotingProgress() {
      this.loading = true;
      const client = new AdminClient(this.currentJwtToken, this.eventId);
      this.missing = await client.getPeopleWhoHaveNotSetPrizePreferences(this.eventId);
      this.loading = false;
    },
  },
};
</script>
